import { db } from '../../firebase/firebaseConfig';
import { doc, getDoc, updateDoc } from 'firebase/firestore';
import { COLLECTIONS } from '../../constants/collections';

/**
 * Fetch tenant information
 */
export const getTenant = async (tenantId) => {
    try {
        const tenantDoc = await getDoc(doc(db, COLLECTIONS.TENANTS, tenantId));
        if (tenantDoc.exists()) {
            return { id: tenantDoc.id, ...tenantDoc.data() };
        }
        return null;
    } catch (error) {
        console.error('Error fetching tenant:', error);
        throw error;
    }
};

/**
 * Update tenant information
 */
export const updateTenant = async (tenantId, tenantData) => {
    try {
        const tenantRef = doc(db, COLLECTIONS.TENANTS, tenantId);
        await updateDoc(tenantRef, {
            ...tenantData,
            updatedAt: new Date()
        });
        return true;
    } catch (error) {
        console.error('Error updating tenant:', error);
        throw error;
    }
};
